
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class FaceVerifyIntro extends Vue {
  @Prop({ type: Boolean, default: false }) notVerify!: boolean;
  @Prop({ type: Boolean, default: false }) loading!: boolean;
  @Prop({ type: String, default: "#525FFF" }) mainColor!: String; //主色调

  start() {
    console.log("start");
    this.$emit("start");
  }
}
